import { Layout, Row, Col } from "antd";
import FullPageLayout from "../../../shared-components/layout/FullPageLayout";
import AllSettings from "./AllSettings/AllSettings";

function AllSettingsPage() {
  return (
    <Layout color="primary" style={{ height: "100vh" }}>
      <FullPageLayout name="organization settings">
        <Row gutter={[0, 16]} align="middle">
          <Col span={24}>
            <AllSettings />
          </Col>
        </Row>
      </FullPageLayout>
    </Layout>
  );
}

export default AllSettingsPage;
